/* CASA · FAILURE REPORTS (23 Sep 2026). The 16-23 Sep www outage happened only in
   shoppers' browsers, so the server never saw it. window.casaSignal(kind, detail)
   tells /api/client-signal that a step failed; /api/cron-health emails Nouvos when
   enough visitors hit one. Called only from existing failure branches (and for
   script errors in this page). Never throws, never blocks, at most 3 reports per
   kind and 8 per page view. Detail is our own error text, never form input. */
(function(){
  var perKind = {}, total = 0;
  window.casaSignal = function(kind, detail){
    try {
      if (!kind || total >= 8 || (perKind[kind] || 0) >= 3) return;
      perKind[kind] = (perKind[kind] || 0) + 1; total++;
      var body = JSON.stringify({ kind: String(kind).slice(0, 40),
        detail: String(detail == null ? '' : detail).slice(0, 300),
        path: String(location.pathname).slice(0, 120) });
      if (navigator.sendBeacon && navigator.sendBeacon('/api/client-signal', new Blob([body], { type: 'text/plain' }))) return;
      fetch('/api/client-signal', { method: 'POST', body: body, keepalive: true,
        headers: { 'Content-Type': 'text/plain' } }).catch(function(){});
    } catch (e) {}
  };
  /* Shopper steps for Vercel Analytics custom events (24 Sep 2026): Quick View,
     Add to Bag, Checkout Started, Checkout Handoff. Product ids and counts only,
     never anything a visitor typed. Never throws; does nothing until the analytics
     snippet at the end of <body> has defined window.va. */
  window.casaTrack = function(name, data){
    try { if (window.va) window.va('event', { name: name, data: data }); } catch (e) {}
  };
  window.addEventListener('error', function(ev){
    try {
      var f = (ev && ev.filename) || '';
      // Only this site's own code: extensions and third-party scripts report as
      // other origins or as a bare "Script error." with no file.
      if (!f || f.indexOf(location.origin) !== 0) return;
      // Instagram's in-app browser injects its own script into the page, so its errors
      // carry our URL. This site never touches window.webkit (24 Sep 2026).
      if (String(ev.message || '').indexOf('webkit.messageHandlers') !== -1) return;
      window.casaSignal('js_error', String(ev.message || '').slice(0, 200) + ' @' + f.slice(location.origin.length) + ':' + (ev.lineno || 0));
    } catch (e) {}
  });
})();
